module.exports = __webpack_public_path__ + "static/media/reject-bid-icon.39db13f4.svg";